export async function collectFingerprint(): Promise<Record<string, unknown>> {
  return {
    ua: navigator.userAgent,
    lang: navigator.language,
    langs: navigator.languages?.join(','),
    platform: navigator.platform,
    cores: navigator.hardwareConcurrency,
    mem: (navigator as any).deviceMemory,
    sw: screen.width,
    sh: screen.height,
    cd: screen.colorDepth,
    dpr: window.devicePixelRatio,
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    touch: navigator.maxTouchPoints,
  }
}
